/* The existing Shopify discount prices the matching guest; stock is checked again before adding. */
if (!customElements.get('embod-retreat-pair')) {
  customElements.define('embod-retreat-pair', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.pending = false;
      this.uncertain = false;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.querySelector('[data-book-pair]').addEventListener('click', () => this.book(), options);
      this.sync = () => this.syncAvailability();
      document.addEventListener('change', this.sync, options);
      document.addEventListener('variant:update', this.sync, options);
      const form = document.getElementById(this.dataset.form);
      if (form) {
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(form, {subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'disabled']});
      }
      this.syncAvailability();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.ready = false;
    }
    selectedRoom() {
      const form = document.getElementById(this.dataset.form);
      return form ? Number(new FormData(form).get('id')) : 0;
    }
    syncAvailability() {
      const room = this.selectedRoom();
      const availability = JSON.parse(this.querySelector('[data-room-availability]').textContent);
      const available = availability[room] === true;
      const button = this.querySelector('[data-book-pair]');
      const status = this.querySelector('[data-pair-status]');
      const disabled = !available || this.pending || this.uncertain;
      if (button.disabled !== disabled) button.disabled = disabled;
      if (!this.pending && !this.uncertain) {
        if (!available && status.textContent !== 'This room is sold out. Choose an available room above.') status.textContent = 'This room is sold out. Choose an available room above.';
        else if (this.lastRoom !== room) status.textContent = '';
      }
      this.lastRoom = room;
      return available;
    }
    async book() {
      if (!this.syncAvailability() || this.pending || this.uncertain) return;
      const button = this.querySelector('[data-book-pair]');
      const status = this.querySelector('[data-pair-status]');
      const room = this.selectedRoom();
      const guest = JSON.parse(this.querySelector('[data-pair-variants]').textContent)[room];
      if (!guest) { status.textContent = 'Please choose a room first.'; return; }
      this.pending = true;
      button.disabled = true;
      status.textContent = 'Checking your room…';
      const root = window.Shopify?.routes?.root || '/';
      let submitted = false;
      try {
        const [roomResponse, guestResponse] = await Promise.all([
          fetch(root + 'products/biohacking-offline-23-25-october-2026.js', {cache: 'no-store'}),
          fetch(root + 'products/biohacking-offline-additional-guest.js', {cache: 'no-store'})
        ]);
        if (!roomResponse.ok || !guestResponse.ok) throw new Error('We could not check availability. Please try again.');
        const [rooms, guests] = await Promise.all([roomResponse.json(), guestResponse.json()]);
        if (!rooms.variants.some(v => v.id === room && v.available)) throw new Error('This room is now sold out. Please choose another room.');
        if (!guests.variants.some(v => v.id === guest && v.available)) throw new Error('The additional guest option is currently unavailable. Please contact Embod before booking for two.');
        if (this.selectedRoom() !== room) throw new Error('Your room selection changed. Please check it and book again.');
        status.textContent = 'Adding your room and your friend…';
        submitted = true;
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [{id: room, quantity: 1}, {id: guest, quantity: 1}]})
        });
        const result = await response.json();
        submitted = false;
        if (!response.ok) throw new Error(result.description || 'Please check room availability and try again.');
        this.uncertain = true; // Keep the button locked until navigation completes.
        window.location.assign(root + 'cart');
      } catch (error) {
        this.uncertain = submitted;
        status.textContent = submitted
          ? 'We could not confirm the cart update. Please check your bag before trying again.'
          : (error instanceof TypeError ? 'We could not check availability. Please try again.' : error.message);
      } finally {
        this.pending = false;
        button.disabled = this.uncertain || !JSON.parse(this.querySelector('[data-room-availability]').textContent)[this.selectedRoom()];
      }
    }
  });
}
